import { render, staticRenderFns } from "./close-button.component.vue?vue&type=template&id=3a34cac6&scoped=true"
import script from "./close-button.component.vue?vue&type=script&lang=js"
export * from "./close-button.component.vue?vue&type=script&lang=js"
import style0 from "./close-button.component.vue?vue&type=style&index=0&id=3a34cac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a34cac6",
  null
  
)

export default component.exports